import clsx from 'clsx'
import React, {FC, useEffect} from 'react'
import {SwapperComponent} from '../../../assets/ts/components'
import {HeaderMenuInner} from './HeaderMenuUnner'

const LandingHeader: FC = () => {
  useEffect(() => {
    SwapperComponent.reinitialization()
  }, [])

  return (
    <div
      id='kt_main_aside'
      className={clsx('header-menu align-items-stretch')}
      data-kt-drawer='true'
      data-kt-drawer-name='header-menu'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_landing_header_menu_mobile_toggle'
      data-kt-swapper='true'
      data-kt-swapper-mode='append'
      data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}"
    >
      <div
        className='menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch'
        data-kt-menu='true'
      >
        <HeaderMenuInner />
      </div>
    </div>
  )
}

export {LandingHeader}
